import React from 'react';
import { DecoratorNode } from 'lexical';
import { Image } from 'antd';

export class ImageNode extends DecoratorNode<React.ReactNode> {
  __src: string;
  __altText: string;
  __style: React.CSSProperties;

  static override getType(): string {
    return 'image';
  }

  static override clone(node: ImageNode): ImageNode {
    return new ImageNode(node.__src, node.__altText, node.__style, node.__key);
  }

  constructor(
    src: string,
    altText: string,
    style: React.CSSProperties,
    key?: string,
  ) {
    super(key);
    this.__src = src;
    this.__altText = altText;
    this.__style = style;
  }

  override createDOM(): HTMLElement {
    const container = document.createElement('span');
    return container;
  }

  override updateDOM(): false {
    return false;
  }

  static override importJSON(serializedNode: any): ImageNode {
    return createImageNode({
      src: serializedNode.src,
      altText: serializedNode.altText,
      style: serializedNode.style,
    });
  }

  override exportJSON(): any {
    return {
      src: this.__src,
      altText: this.__altText,
      style: this.__style,
      type: 'image',
      version: 1,
    };
  }

  override decorate(): React.ReactNode {
    return <Image src={this.__src} alt={this.__altText} style={this.__style} />;
  }
}

export function createImageNode({
  src,
  altText,
  style,
}: {
  src: string;
  altText: string;
  style: React.CSSProperties;
}): ImageNode {
  return new ImageNode(src, altText, style);
}
